import { Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import { Header, TabNames } from "./components/Header/Header";
import { Footer } from "./components/Footer/Footer";
import { Contact } from "./components/Contact/Contact";
import { Home } from "./components/Home/Home";
import { Product } from "./components/Product/Product";
import { Development } from "./components/Development/Development";
import { Apply } from "./components/Apply/Apply"
import { About } from "./components/About/About";
import { useEffect, useState } from "react";
import { MenuItemProps } from "semantic-ui-react";
// import { Mobile } from "./components/MobileF/Mobile";
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import "./App.css";
import { Training } from "./components/Training/Training";
import { CourseDetails } from "./components/Training/CourseDetails";
import Chatbot from "react-chatbot-kit";
import bot from "./images/ISicon1.png";
import config from "./config.js";
import MessageParser from "./MessageParser.jsx";
import ActionProvider from "./ActionProvider.jsx";
import CloseIcon from '@mui/icons-material/Close';
import { LoginPortal } from "./components/LoginPortal/LoginPortal";

 

export const App = () => {
  const [activeItem, setActiveItem] = useState<TabNames>(TabNames.HOME);
  const location = useLocation()
  const [showBot, toggleBot] = useState(false);
  const [isZoomingOut, setIsZoomingOut] = useState(false);
  const [navBg, setNavBg] = useState(true);

  const handleBotClick = () => {
    if (!showBot) {
      // If bot is not showing, trigger zoomout animation first
      setIsZoomingOut(true);
      setTimeout(() => {
        toggleBot(true);
        setIsZoomingOut(false);
      }, 600); // Match animation duration
    } else {
      // If bot is showing, just toggle it
      toggleBot(false);
    }
  }
  useEffect(() => {
    // Intersection Observer to determine if objects are within the viewport
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        } else {
          entry.target.classList.remove('in-view');
        }
      });
    });

    // Function to observe all elements with the .animate class
    const observeElements = () => {
      const allAnimatedElements = document.querySelectorAll('.animate');
      allAnimatedElements.forEach(element => observer.observe(element));
    };

    // Observe initial elements
    observeElements();

    // MutationObserver to detect DOM changes
    const mutationObserver = new MutationObserver(() => {
      observeElements(); // Reapply IntersectionObserver to new elements
    });

    // Observe the body for changes
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      // Cleanup IntersectionObserver
      observer.disconnect();
      // Cleanup MutationObserver
      mutationObserver.disconnect();
    };
  }, []); // Re-run when `trigger` changes

  const changeNavBg = () => {
      window.scrollY >= 150 ? setNavBg(true) : setNavBg(false);
     }
   
     
     useEffect(() => {
       window.addEventListener('scroll', changeNavBg);
       return () => {
         window.removeEventListener('scroll', changeNavBg);
       }
     }, []);
     const scrollToTop = () => {
      window.scrollTo(0,0);
     }

  let [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const pathname1 = location.pathname.split("?")[0];  
    console.log(pathname1,'ssssss');
          
    switch(pathname1) {
        case "/product":
            setActiveItem(TabNames.PRODUCTS);
            break;
            case "/development":
              setActiveItem(TabNames.PRODUCTS);
              break;
              case "/training":
                setActiveItem(TabNames.PRODUCTS);
                break
            case "/apply":
              setActiveItem(TabNames.MOBILE);
              break;
        case "/contact":
            setActiveItem(TabNames.CONTACT);
            break;
            case "/demo":
            setActiveItem(TabNames.DEMO);
            break;
        case "/about-us":
            setActiveItem(TabNames.ABOUT_US);
            break;
            case "/login":
              setActiveItem(TabNames.LOGIN_PORTAL);
              break;
        default:
            setActiveItem(TabNames.HOME);
            break;
    }        
  }, [location.pathname])

  const handleItemClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
    if (data.name) {
        setActiveItem(data.name as TabNames);
        console.log(data.name,TabNames.PRODUCTS,"namesssss");
        
        if (data.name === TabNames.PRODUCTS) 
        {
          setSearchParams({q:'Class_Student'})
        }
        
    }
  }

  return (
    <>
      <Header activeItem={activeItem} handleItemClick={handleItemClick} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<Product />} />
          <Route path="/development" element={<Development />} />
          <Route path="/training" element={<Training />} />
          <Route path="/training/course/:courseId" element={<CourseDetails />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/login-portal" element={<LoginPortal />} />
        </Routes>
      <Footer activeItem={activeItem} handleItemClick={handleItemClick}/>
   
      <ArrowUpwardOutlinedIcon className= {navBg ? ('Uparrow') : ('UparrowHiden')} onClick={scrollToTop}></ArrowUpwardOutlinedIcon>
      {showBot && (
        
        <div className="app-chatbot-container">
          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
          />
        </div>
      
    )}
  <button
        className="app-chatbot-button"
        onClick={handleBotClick}
      >
      {!showBot && (
          
        <div className="chatbot-text">Hey there If you need any <br></br>assistance, I'm here to help!</div>)}
        <div style={{backgroundColor:'#F5FAFB'}} className={`app-chatbot-button-botbox ${!showBot ? 'glowPulse' : ''}`}>  
        {!showBot == true  ?  
           <img src={bot} alt='Q-bot'  style={{width: '100%', height: '100%',}} className={`bot-icon ${isZoomingOut ? 'zooming-out' : ''}`}/> : <CloseIcon className= 'close-icon'>

           </CloseIcon>}
           </div>
     
     
      </button>  
    </>
  );
}